import { combineReducers } from 'redux';
import layout, {actions as layoutActions} from './layout';
import auth, {actions as authActions} from './auth';
import appData, {actions as appDataActions} from './appData';
import businessPartners, {actions as bpActions} from './businessPartners';
import salesOrders, {actions as soActions} from './salesOrders';
import salesorderLines, {actions as soLineActions} from './salesorderLines';
import payments, {actions as paymentActions} from './payments';
import accounting, {actions as accountingActions} from './accounting';
import notifications, {actions as notificationsActions} from './notifications';
import items, {actions as itemActions} from './items';
import copyDoc, {actions as copyDocActions} from 'containers/BusinessPartners/BottomTabs/CopyDocFromBP/copyDoc.redux';


export const reducers = combineReducers({
	layout,
	auth,
	appData,
	businessPartners,
	salesOrders,
	payments,
	accounting,
	notifications,
	salesorderLines,
	items,
	copyDoc,
});


export const actions = {
	layout: layoutActions,
	auth: authActions,
	appData: appDataActions,
	businessPartners: bpActions,
	salesOrders: soActions,
	payments: paymentActions,
	accounting: accountingActions,
	notifications: notificationsActions,
	salesorderLines: soLineActions,
	items: itemActions,
	copyDoc: copyDocActions,
};